export const UserRolesConstants = {
  CustomerUTPAdmin: "CustomerUTPAdmin",
  CustomerAdminUser: "CustomerAdminUser",
  ManagedSurveysSuperAdmin: "ManagedSurveysSuperAdmin",
};
